import React from 'react';
import {Field} from 'redux-form';
import {Form, Row, Col} from 'react-bootstrap';
import {Button} from '@material-ui/core';
import * as fields from 'components/common/fields';
import * as validators from 'utils/validators';
import {makeForm, levelMap} from 'utils/common';
import * as permissions from 'utils/permissions';

class UserUpdateForm extends React.Component {
  render() {
    const {isMe, me, user, canEditNativeLevel, handleSubmit, pristine, submitting} = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        {!isMe && permissions.isKluwellAdmin(me.role) && (
          <Row>
            <Col md={12}>
              <Field name="email" label="E-mail Address" component={fields.Input} validate={[validators.isEmail]} />
            </Col>
            <Col md={6}>
              <Field name="password" label="Reset Password" component={fields.Input} type="password" />
            </Col>
            <Col md={6}>
              <Field
                name="confirmPassword"
                label="Confirm Password"
                component={fields.Input}
                type="password"
                validate={[validators.isConfirmPasswordMatch]}
              />
            </Col>
          </Row>
        )}
        <Row>
          {(permissions.isSchoolCoordinator(me.role) && permissions.isTeacher(user.role)) ||
          (permissions.isSchoolCoordinatorOrTeacher(me.role) && permissions.isReader(user.role)) ||
          (permissions.isParent(me.role) && permissions.isReader(user.role)) ? (
            <React.Fragment>
              <Col md={6}>
                <Field name="email" label="E-mail Address" component={fields.Input} validate={[validators.isEmail]} />
              </Col>
              <Col md={6}>
                <Field
                  name="username"
                  label="Username"
                  component={fields.Input}
                  required
                  validate={[validators.isRequired, validators.isUsername]}
                />
              </Col>
              <Col md={6}>
                <Field name="password" label="Reset Password" component={fields.Input} type="password" />
              </Col>
              <Col md={6}>
                <Field
                  name="confirmPassword"
                  label="Confirm Password"
                  component={fields.Input}
                  type="password"
                  validate={[validators.isConfirmPasswordMatch]}
                />
              </Col>
            </React.Fragment>
          ) : (
            <Col md={12}>
              <Field
                name="username"
                label="Username"
                component={fields.Input}
                required
                validate={[validators.isRequired, validators.isUsername]}
              />
            </Col>
          )}
          <Col md={6}>
            <Field
              name="firstName"
              label="First Name"
              component={fields.Input}
              required
              validate={[validators.isRequired]}
            />
          </Col>
          <Col md={6}>
            <Field
              name="lastName"
              label="Last Name"
              component={fields.Input}
              required
              validate={[validators.isRequired]}
            />
          </Col>
          {/*{*/}
          {/*canEditNativeLevel && (*/}
          {/*<Col md={6}>*/}
          {/*<Field*/}
          {/*name="level"*/}
          {/*label="Default App Level"*/}
          {/*labelKey="label"*/}
          {/*valueKey="value"*/}
          {/*component={fields.Select}*/}
          {/*options={[*/}
          {/*{value: 1, label: 'Yellow'},*/}
          {/*{value: 2, label: 'Green'},*/}
          {/*{value: 3, label: 'Orange'},*/}
          {/*]}*/}
          {/*/>*/}
          {/*</Col>*/}
          {/*)*/}
          {/*}*/}
        </Row>
        <Row>
          <Col xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={pristine || submitting}>
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = (state) => {
  const {account, users} = state;
  const me = account.get('user').toJS();
  const user = users.get('currentUser').toJS();
  const initialValues = {
    email: user.email,
    username: user.username,
    firstName: user.firstName,
    lastName: user.lastName,
  };
  if (permissions.isReader(user.role)) {
    initialValues.level = {value: user.nativeLevel, label: levelMap[user.nativeLevel]};
  }
  return {
    canEditNativeLevel: false,
    // canEditNativeLevel: permissions.isParent(me.role) && permissions.isReader(user.role),
    isMe: me.id === user.id,
    me,
    user,
    initialValues,
  };
};

export default makeForm(UserUpdateForm, 'UserUpdateForm', mapStateToProps, null);
